import { createSlice } from '@reduxjs/toolkit';
import { EMSPService } from '_apis_/emsp';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

type EMSState = {
  isLoading: boolean;
  error: boolean;
  emspList: any[];
  emspListCount: number;
};

const initialState: EMSState = {
  isLoading: false,
  error: false,
  emspList: [],
  emspListCount: 0
};

const emspService = new EMSPService();

const emspSlice = createSlice({
  name: 'emsp',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET BOOST SUCCESS
    getEMSPListSuccess(state, action) {
      state.isLoading = false;
      state.emspList = action.payload;
      state.emspListCount = action.payload.length;
    }
  }
});

// ----------------------------------------------------------------------

export function getEMSPList(cpoId: string | undefined, currentRows = 0, records = 10) {
  return async () => {
    dispatch(emspSlice.actions.startLoading());
    try {
      const response = await emspService.getEMSPList(cpoId, currentRows, records);
      dispatch(emspSlice.actions.getEMSPListSuccess(response?.data?.data));
    } catch (error) {
      dispatch(emspSlice.actions.hasError(error));
    }
  };
}

// Reducer
export default emspSlice.reducer;
